/** How long after the last pen event touches are still treated as palm. */
export const PEN_GRACE_MS = 600;
/** Contact size (CSS px) above which a touch is treated as palm regardless of pen state. */
export const PALM_CONTACT_PX = 60;

/**
 * Decides whether a finger touch may scroll/zoom. Fingers never draw; this
 * only protects navigation from a resting palm.
 */
export class PalmFilter {
  private penDown = false;
  private lastPen = -Infinity;

  notePen(timeStamp: number, down: boolean): void {
    this.lastPen = Math.max(this.lastPen, timeStamp);
    this.penDown = down;
  }

  /** True while the pen is touching, or was seen (touching or hovering) within the grace period. */
  penActive(timeStamp: number): boolean {
    return this.penDown || timeStamp - this.lastPen < PEN_GRACE_MS;
  }

  acceptTouch(timeStamp: number, width: number, height: number): boolean {
    if (this.penActive(timeStamp)) return false;
    return Math.max(width, height) < PALM_CONTACT_PX;
  }
}
